export enum CambioEstadoCivilEnum {
  UNDEFINED = 0,
  SINGLE = 1,
  MARRIED = 2,
  SEPARATED = 3,
  WIDOWER = 4,
  FREE_UNION = 5
}

export enum CambioEstadoCivilEnumMap {
  UNDEFINED = "0",
  SINGLE = "1",
  MARRIED = "2",
  SEPARATED = "3",
  WIDOWER = "4",
  FREE_UNION = "5"
}


export function esCambioValidoDeEstadoCivil(origen: any, destino: any): boolean {
  const {SINGLE, WIDOWER, SEPARATED, FREE_UNION, MARRIED} = CambioEstadoCivilEnumMap;
  const destinosInvalidos = [SINGLE, WIDOWER, SEPARATED];
  if (destinosInvalidos.includes(destino)) {
    return false;
  }
  return !(origen === FREE_UNION && destino === MARRIED);
}

